// Cognito OIDC settings for react-oidc-context, in one place for sign-in
// (index.js) and sign-out (signOut.js).
import { WebStorageStateStore } from 'oidc-client-ts';
import { clearAuthParamsFromUrl } from './oidcCallback.js';

export const COGNITO = Object.freeze({
  authority: 'https://cognito-idp.us-east-2.amazonaws.com/us-east-2_0P2WZow21',
  clientId: '6vk20av8lf26ompgr4r982t0n',
  domain: 'https://tickrtrends.auth.us-east-2.amazoncognito.com',
  redirectUri: 'https://tickrtrends.com/members',
  logoutUri: 'https://tickrtrends.com/',
});

/**
 * The signed-in user (ID, access and refresh tokens) lives in localStorage
 * rather than oidc-client-ts's default sessionStorage, so a session survives
 * new tabs and browser restarts. Tradeoff: tokens persist on the device until
 * Sign Out or expiry (see docs/members-api-design.md, "Session storage").
 * @param {Storage} [storage]
 */
export const createOidcConfig = (storage = window.localStorage) => ({
  authority: COGNITO.authority,
  client_id: COGNITO.clientId,
  redirect_uri: COGNITO.redirectUri,
  response_type: 'code',
  scope: 'openid email profile',
  onSigninCallback: clearAuthParamsFromUrl,
  userStore: new WebStorageStateStore({ store: storage }),
});
